import ChartsLayout from "./ChartLayout";

export default ChartsLayout;
